import { GetServerSideProps } from "next";
import dynamic from "next/dynamic";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { USER_ACCOUNT_URI } from "@looksrare/config";
import { getIsValidAddress, withGuessedBreakpoint } from "@looksrare/utils";
import { useUser } from "hooks/graphql/user";
import Page from "components/Layout/Page";
import { useAddressFromQuery } from "views/account/hooks/useAddressFromQuery";
import AccountSeo from "views/account/components/AccountSeo";

const SettingsNotificationsView = dynamic<unknown>(
  () =>
    import("../../../../views/account/SettingsNotificationsView").then((module) => module.SettingsNotificationsView),
  { ssr: false }
);

const NotificationsSettingsPage: React.FC = () => {
  const address = useAddressFromQuery();
  const { data: user } = useUser(address!, { enabled: !!address, refetchOnWindowFocus: false });

  return (
    <Page>
      <AccountSeo user={user} />
      <SettingsNotificationsView />
    </Page>
  );
};

export const getServerSideProps: GetServerSideProps = withGuessedBreakpoint(async ({ locale, query }) => {
  const address = query?.address as string;
  const isValidAddress = address === USER_ACCOUNT_URI || getIsValidAddress(address!);

  if (!isValidAddress) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      ...(await serverSideTranslations(locale!, ["common"])),
      locale,
    },
  };
});

export default NotificationsSettingsPage;
